import { AppConsts } from '../../../shared/AppConsts';
var DefaultSimulateRemoteImageProtocol = /** @class */ (function () {
    function DefaultSimulateRemoteImageProtocol() {
        this.remoteServiceBaseUrl = AppConsts.remoteServiceBaseUrl;
        this.appBaseUrl = AppConsts.appBaseUrl;
    }
    return DefaultSimulateRemoteImageProtocol;
}());
export { DefaultSimulateRemoteImageProtocol };
